/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Fast Promised Payment component
 *
 * @author Nikolay Sviridov
 * @version 1.36.1
 * @since 1.36.0
 */

import { useEffect } from 'react';

import { Typography } from '@nexign/scc-ui-kit';
import includes from 'lodash/includes';
import { useSelector } from 'react-redux';

import { EFastActionsButtonTypes } from '@/main/components/FastActions/constants/constants';
import { useGetFastActionsQuery } from '@/main/components/FastActions/store';
import { EFastBasketSwitchboxContext } from '@/main/components/Table/constants';
import { makeSelectTranslationPagePersonalAccount } from '@/main/modules/internationalization/intSelectors';
import { openRoute } from '@/main/routes/constants/externalRoutes';
import { RoutePath } from '@/main/routes/constants/routesConstants';

import PagePersonalAccount from '../PagePersonalAccount/PagePersonalAccount';


export const FastPromisedPayment = () => {

    const { title } = useSelector(makeSelectTranslationPagePersonalAccount());

    const { data: fastActionsData, isSuccess: isFastActionsDataSuccess } = useGetFastActionsQuery();

    useEffect(() => {
        if (
            !includes(fastActionsData?.buttons, EFastActionsButtonTypes.INQUIRY_CREATE) &&
            isFastActionsDataSuccess
        ) {
            openRoute(RoutePath.dashboard);
        }
    }, [fastActionsData, isFastActionsDataSuccess]);

    return (
        <>
            <Typography className="page-title" variant="h3">
                {title.fastPromisedPaymentTitle}
            </Typography>

            <Typography isDangerousInnerHTML variant="body1">
                {title.fastPromisedPaymentSubtitle}
            </Typography>

            <PagePersonalAccount 
                isFastActionPage
                isFastBasketPage
                basketContext={EFastBasketSwitchboxContext.MAIN_OPERATIONS}
            />
        </>
    );
};
